import { AuthCancelledError, type AuthRecord } from "./AuthTypes";
import { AuthSession } from "./AuthSession";
import { ensureAuthElements } from "./AuthMount";

type LoginResolver = {
  resolve: (record: AuthRecord) => void;
  reject: (error: Error) => void;
};

let resolvers: LoginResolver[] = [];
let popup: {
  show: () => void;
  hide: () => void;
} | null = null;

export function registerLoginPopup(host: { show: () => void; hide: () => void }) {
  popup = host;
}

export function requestLogin(): Promise<AuthRecord> {
  const existing = AuthSession.get();
  if (existing?.ticket) return Promise.resolve(existing);
  ensureAuthElements();
  if (!popup) {
    return Promise.reject(new Error("Login popup is not registered"));
  }
  popup.show();
  return new Promise<AuthRecord>((resolve, reject) => {
    resolvers.push({ resolve, reject });
  });
}

export function completeLogin(record: AuthRecord) {
  const waiting = resolvers;
  resolvers = [];
  popup?.hide();
  waiting.forEach((item) => item.resolve(record));
}

export function cancelLogin() {
  const waiting = resolvers;
  resolvers = [];
  popup?.hide();
  waiting.forEach((item) => item.reject(new AuthCancelledError()));
}

export async function ensureAuth(): Promise<AuthRecord> {
  const existing = AuthSession.get();
  if (existing?.ticket) return existing;
  return requestLogin();
}
